export default __webpack_public_path__ + "static/media/5.a5bbd902.jpeg";